// frontend/src/utils/FeesTypeEnum.js

const FeesTypeEnum = Object.freeze({
  ADMISSION: "admission",
  SPECIAL_CHANCE: "special_chance",
  QR_CODE: "qr_code",
  CASH: "cash",
  // Add more fee types as needed
});
export default FeesTypeEnum;
